import { type ReactNode } from 'react'

import { LegalPage } from './LegalPage'
import { PRIVACY_POLICY } from '../content/legal'

/** `/privacy` — M17-T17. Text approved by AMTC; see `docs/legal/`. */
export function Privacy(): ReactNode {
  return <LegalPage doc={PRIVACY_POLICY} />
}
